import styled from 'styled-components';
import { lightGray } from '../../utils/style/colors';

export const ActionMenuButton = styled('a')`
  float: left;
  padding: 0px 2px;
  i {
    width: 3.2rem;
  }
`;

export const MoreSpan = styled('span')`
  align-items: center;
  display: flex;
  flex-direction: row-reverse;
  height: 100%;
  // width: 200px;
`;

interface TagProps {
  deleted: boolean;
}

export const TagText = styled.span<TagProps>`
  ${({ deleted }) => (deleted ? `color: ${lightGray}` : '')}
`;
